module.exports = __webpack_public_path__ + "media/music/piano_3-aa28ea8e.mp3";